export const generateUniqueId = () => {
  // Use native method if available (all modern browsers)
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback for older browsers
  // based on answer from https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid/2117523#2117523
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = crypto.getRandomValues(new Uint8Array(1))[0];
    const v = c === 'x' ? r & 0xf : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Utility function to hash email addresses for analytics tracking
 * Uses SHA-256 for secure one-way hashing
 * @param {string} email - The email address to hash
 */
export const hashEmail = async (email) => {
  try {
    // Convert email to lowercase for consistency
    const normalizedEmail = email.toLowerCase().trim();

    // Convert string to Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(normalizedEmail);

    // Generate hash using SHA-256
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Convert buffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');

    return hashHex;
  } catch (error) {
    console.error('Error hashing email:', error);
    // Fallback to a non-reversible string in case of error
    return `HASH_ERROR_${Date.now()}`;
  }
};

function convertToPascalCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function convertObjectKeysToPascalCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertObjectKeysToPascalCase(item));
  }

  if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      const pascalCaseKey = convertToPascalCase(key);
      acc[pascalCaseKey] = convertObjectKeysToPascalCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}
